import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authedRoute } from '../../app/routes-base';

export const dapurRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: 'dapur',
  component: lazyRouteComponent(() => import('./layout'), 'DapurLayout'),
});

const dapurBoardRoute = createRoute({
  getParentRoute: () => dapurRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./board-page'), 'KitchenBoardPage'),
});

const dapurMenuRoute = createRoute({
  getParentRoute: () => dapurRoute,
  path: 'menu',
  component: lazyRouteComponent(() => import('../../shared/menu/menu-page'), 'MenuPage'),
});

const dapurRequestsRoute = createRoute({
  getParentRoute: () => dapurRoute,
  path: 'permintaan',
  component: lazyRouteComponent(() => import('./requests-page'), 'KitchenRequestsPage'),
});

export const dapurTree = dapurRoute.addChildren([
  dapurBoardRoute,
  dapurMenuRoute,
  dapurRequestsRoute,
]);
